import {
    ComponentElements,
    ComponentInjector,
    ComponentObject,
    ComponentSelector,
    ComponentService,
    ComponentSelectors,
} from '@atypon/ui-utils';
class Texts extends ComponentObject { }

class ClassList extends ComponentObject {
    seeMore = 'loi--see-more__link';
    hide = 'hidden';
}

class Selectors extends ComponentSelectors {
    spinner = new ComponentSelector('.loi__spinner');
    list = new ComponentSelector('.lot');
}

class Elements extends ComponentElements<Selectors> {
    spinner: HTMLElement;
    list: HTMLElement;
}

interface MediaTab extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class MediaTab {
    isLazyLoading = false;
    showCoverImage = '';
    displayAuthors = '';
    seriesItem = require('../templates/list-of-issues-detailed/media-series-item-client.jade');
    constructor(readonly wrapper: HTMLElement) { }

    initialize(): void {
        this.elements.initialize(this.wrapper);
        this.isLazyLoading = this.elements.list.dataset.lazyload === 'true';
        this.showCoverImage = this.elements.list.dataset.showCoverImage;
        this.displayAuthors = this.elements.list.dataset.displayAuthors;
        if (this.isLazyLoading) {
            this.sendAjax(this.elements.list.dataset.source)
        }
        this.addEventListeners();
    }

    addEventListeners() {        
        this.elements.list.addEventListener('click', this.onClick.bind(this));
    }

    onClick(e: Event) {
        e.stopPropagation();
        const target = e.target as HTMLElement;
        if (!target.classList.contains(this.classList.seeMore)) {
            return;
        }
        let parentLi = target.parentElement,
            ajaxUrl = target.dataset.source;
        parentLi.remove();
        this.sendAjax(ajaxUrl);
    }



    async sendAjax(url) {
        // url = 'ajax/content.json'
        try {

            this.setIsLoading(true);
            const response = await fetch(url);
            const data = await response.json();
            if (!data.data.items.length) {
                return;
            }
            const html = data.data.items.map(item => {
                return this.listItem(item);
            }).join('');
            this.elements.list.insertAdjacentHTML('beforeend', html);
            if (data.showMore) {
                this.elements.list.insertAdjacentHTML('beforeend', this.seeMore(data.showMoreUrl));
            }
            this.setIsLoading(false);
        } catch (e) {
            this.setIsLoading(false);
        }
    }

    setIsLoading(done) {
        this.elements.spinner.classList.toggle(this.classList.hide, !done);
    }

    seeMore(link) {
        return `
            <li class="loi--see-more">
                <a href="javascript:void(0)" data-source="${link}" class="loi--see-more__link btn">Show more</a>
            </li>
        `;
    }

    listItem(item) {
        let showCoverImage = this.showCoverImage === "true" ? true : false;
        let displayAuthors = this.showCoverImage === "true" ? true : false;
        return this.seriesItem({showCoverImage:showCoverImage, displayAuthors:displayAuthors, item});
    }
}

export default MediaTab;

export {
    Elements as MediaTabElements,
    Selectors as MediaTabSelectors,
    ClassList as MediaTabClassList,
    Texts as MediaTabTexts
}
